
/** 
 * Cart
 * Cart Display 
 * Initializes line item remove + quantity updates
 * Listes for removed and quantity updates
 **/
import eventBus from "../../core/services/event-bus"
const CartAwareProductForm = function( $product, $current_variant , $container){
    Shopify.theme = Shopify.theme || {};
    let $theme = Shopify.theme;
    const cartService = Shopify.cartService; 
    let $this = {};
    $this.classes = {
        hide : 'd-none' ,
    }
    $this.selectors = {
        quantityComponent : '[sh-quantity-component]',
        btnAddToCart : '[sh-add-to-cart]'
    }
    $this.init = function( ){

        $this.container = $container;
        $this.product = $product;
        $this.current_variant = $current_variant;
        $this.container.setAttribute( 'data-cart-item', true );
        if( typeof( $theme.cartOnLoad) !== 'undefined'){
            $this.cart = $theme.cartOnLoad;
        }
        $this.initElements();
        eventBus.on( eventBus.types.QuantityUpdated , $this.onQuantityUpdated )
        eventBus.on( eventBus.types.CartUpdated  , $this.onCartUpdated );
        if( $this.product.variants.length > 1 ){
            eventBus.on( eventBus.types.OptionsSelected  , $this.onOptionsSelected );
        }
    }

    $this.checkCart = function(  ){
        let $inCart =  false;
        $this.cart.items.forEach( function( item ) {
            if( !$inCart ){
                if( item.variant_id == $this.current_variant.id) {
                    $inCart = true
                    $this.container.setAttribute( 'data-cart-item-key', item.key );
                    $this.quantityComponent.querySelector('input').value = item.quantity
                }
            }
        });
        $this.updateDisplay( $inCart  )
    }

    $this.initElements = function(){
        $this.quantityComponent = $this.container.querySelector( $this.selectors.quantityComponent  );
        $this.btnAddToCart = $this.container.querySelector( $this.selectors.btnAddToCart );
        $this.quantityComponent.dataset.variantId = $this.current_variant.id;
        $this.quantityComponent.dataset.productId = $this.product.id;
        $this.checkCart();

    }
    $this.onOptionsSelected = function( $event ){
        $this.current_variant = $event.detail;
        $this.initElements();
    }

    $this.onCartUpdated = function( $event ){
        $this.cart = $event.detail;
        $this.checkCart();
    }
    

    // update the product display
    // hide the quantity 
    $this.updateDisplay = function( $showQuantity = false  ){
        if( $showQuantity ){
            $this.quantityComponent.classList.remove( $this.classes.hide )
            $this.btnAddToCart.classList.add( $this.classes.hide )
        }
        else{
            $this.quantityComponent.querySelector( 'input' ).value = 1;
            $this.quantityComponent.classList.add( $this.classes.hide )
            $this.btnAddToCart.classList.remove( $this.classes.hide )
        }

    }

    return $this;


}

export default CartAwareProductForm